import { buildWhatsAppHref } from "@/lib/whatsapp";

/** Status vindos de `AutomaticStayLine`; linhas manuais não têm status. */
export type QuoteLineStatus = "charged" | "paid_by_plan" | "not_configured" | "plan_charge";

export interface QuoteLineInput {
  itemName: string;
  quantity: number;
  unitPrice: number;
  status?: QuoteLineStatus;
}

export interface BuildComandaQuoteTextArgs {
  petName: string;
  moduleLabel: string;
  dateLabel: string;
  lines: QuoteLineInput[];
  total: number;
  header: string;
  totalLabel: string;
  paidByPlanLabel: string;
  priceNotConfiguredLabel: string;
  formatCurrency: (value: number) => string;
}

/**
 * O orçamento que vai para o WhatsApp do responsável. Mesmo formato na comanda
 * da reserva e na da estadia — é o texto que a clínica cola na conversa.
 */
export function buildComandaQuoteText(args: BuildComandaQuoteTextArgs): string {
  const items = args.lines
    .map((line) => {
      const value = line.status === "paid_by_plan"
        ? args.paidByPlanLabel
        : line.status === "not_configured"
          ? args.priceNotConfiguredLabel
          : args.formatCurrency(line.quantity * line.unitPrice);
      return `• ${line.quantity}x ${line.itemName} — ${value}`;
    })
    .join("\n");

  return [
    `*${args.header}*`,
    `${args.petName} · ${args.moduleLabel} · ${args.dateLabel}`,
    "",
    items,
    "",
    `*${args.totalLabel}: ${args.formatCurrency(args.total)}*`,
  ].join("\n");
}

/**
 * Abre a conversa do responsável com o texto pronto. Sem telefone válido, abre
 * o seletor de contato do WhatsApp com o texto — a clínica escolhe para quem
 * mandar, em vez de o botão não fazer nada.
 */
export function openWhatsAppWithText({ phone, text, targetWindow }: { phone: string | null; text: string; targetWindow?: WindowProxy | null }) {
  const href = phone ? buildWhatsAppHref(phone, { text }) : null;
  const url = href ?? `https://wa.me/?text=${encodeURIComponent(text)}`;
  if (targetWindow) {
    targetWindow.location.href = url;
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

export const openComandaQuoteOnWhatsApp = openWhatsAppWithText;
